import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IHomebanner, IHomebannersState } from '../../types/store';

const initialState: IHomebannersState = {
  banners: [],
  bannerGroups: ['image_carousel', 'single_banner_1', 'explore_all'],
};

const homebannersSlice = createSlice({
  name: 'homebannersSlice',
  initialState,
  reducers: {
    setBannerGroups: (state, action: PayloadAction<string[]>) => {
      state.bannerGroups = action.payload;
    },
    setHomebanners: (state, action: PayloadAction<IHomebanner[]>) => {
      state.banners = action.payload;
    },
    resetData: (state) => {
      state.banners = initialState.banners;
      state.bannerGroups = initialState.bannerGroups;
    },
    deleteBanner: (state, action: PayloadAction<string>) => {
      state.banners = state.banners?.filter((x: IHomebanner) => x.id != action.payload);
    },
  },
});

export const { resetData, setBannerGroups, setHomebanners, deleteBanner } =
  homebannersSlice.actions;

export default homebannersSlice.reducer;
